import { Link } from 'react-router-dom';

const StudentsTable = ({ students }) => {
    //console.log(students);
    return (       
        <table className="mt-4">
            <thead>
                <tr>
                    <th>Name</th>
                    <th className="hide-on-small-only">Date Of Birth</th>
                    <th className="hide-on-small-only">Gender</th>
                    <th className="hide-on-small-only">ID No.</th>
                    <th>Course</th>
                    <th>Email</th>
                </tr>
                </thead>
                <tbody>          
                {
                    students.length !== 0 && students.map(student => (
                        <tr key={student.idNumber}>
                            <td>{student.title} {student.forenames} {student.surname}</td>
                            <td className="hide-on-small-only">{student.dob}</td>    
                            <td className="hide-on-small-only">{student.gender}</td>    
                            <td className="hide-on-small-only">{student.idNumber}</td>    
                            <td>{student.class}</td> 
                            <td>{student.email}</td>
                            <td><Link to={`/bursary-students/${student.id}`} className="button is-success is-small">Add Fees</Link></td>
                        </tr>
                    ))
                }   
            </tbody>
        </table>
     );
}
 
export default StudentsTable;